module.exports = __webpack_public_path__ + "img/Checkbox.e4f013f2.svg";